import React from 'react'

type InfoCardProps = React.HTMLAttributes<HTMLDivElement> & {
  title: string
  children: React.ReactNode
  colSpan?: number
  rowSpan?: number
  titleAlign?: 'left' | 'center'
  contentAlign?: 'top' | 'center' | 'bottom'
}

const SPAN_CLASSES: Record<string, Record<number, string>> = {
  col: { 2: 'lg:col-span-2', 3: 'lg:col-span-3' },
  row: { 2: 'lg:row-span-2', 3: 'lg:row-span-3' },
}

const CONTENT_ALIGN_CLASSES: Record<string, string> = {
  top: 'items-start',
  center: 'items-center',
  bottom: 'items-end',
}

const InfoCard: React.FC<InfoCardProps> = ({
  title,
  children,
  colSpan,
  rowSpan,
  titleAlign = 'left',
  contentAlign = 'bottom',
  className = '',
  ...props
}) => {
  const spanClasses = [
    colSpan ? SPAN_CLASSES.col[colSpan] ?? '' : '',
    rowSpan ? SPAN_CLASSES.row[rowSpan] ?? '' : '',
  ].join(' ')

  return (
    <div
      className={`bg-cream rounded-md border border-gray-light p-4 overflow-hidden flex flex-col shadow-subtle ${spanClasses} ${className}`}
      {...props}
    >
      <h3 className={`text-lg font-semibold text-dark-blue mb-3 ${titleAlign === 'center' ? 'text-center' : 'text-left'}`}>
        {title}
      </h3>
      <div className={`flex-1 flex justify-center ${CONTENT_ALIGN_CLASSES[contentAlign]}`}>
        {children}
      </div>
    </div>
  )
}

export default InfoCard
